// import { Component, OnInit } from '@angular/core';
// import { productContent, productIcons, productsImages, productsRoutes, productsSku, rightArrowIcon } from '../../constants';
// import { ProductsService } from '../products/products.service';

// @Component({
//   selector: 'app-services-style-two',
//   templateUrl: './services-style-two.component.html',
//   styleUrls: ['./services-style-two.component.scss']
// })
// export class ServicesStyleTwoComponent implements OnInit {

//   products: any = [];
//   constructor(
//     public productsService: ProductsService,
//   ) { }

//   productsDetails = productContent;
//   productsImages = productsImages;
//   productsRoutes = productsRoutes;
//   productIcons = productIcons;
//   rightArrowIcon = rightArrowIcon.arrowIcon;
//   isLoading = false;
//   request = productContent.request;
//   quote = productContent.quote;
//   productsSku = productsSku;


//   ngOnInit(): void {
//     this.listProducts();
//   }

//   listProducts() {
//     this.isLoading = true;
//     this.productsService.listProducts().then((productRes: any) => {
//       this.products = productRes && productRes.data && productRes.data.allProducts && productRes.data.allProducts.nodes && productRes.data.allProducts.nodes.length > 0 ? productRes.data.allProducts.nodes : [];

//       this.productsService.formatProductsData(this.products).then((formatRes) => {
//         console.log("this.products", this.products)
//         this.products = formatRes
//         this.isLoading = false;

//       }).catch((formatErr) => {
//         this.isLoading = false;
//       })
//     }).catch((productErr) => {
//       this.isLoading = false;
//       this.products = [];
//       console.log("🚀 ~ file: services-style-two.component.ts:27 ~ ServicesStyleTwoComponent ~ this.productsService.listProducts ~ productErr:", productErr)
//     })
//   }

// }



import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {
    productContent,
    productIcons,
    productsImages,
    productsRoutes,
    productsSku,
    rightArrowIcon
} from '../../constants';

import { ProductsService } from '../products/products.service';

@Component({
    selector: 'app-services-style-two',
    templateUrl: './services-style-two.component.html',
    styleUrls: ['./services-style-two.component.scss']
})
export class ServicesStyleTwoComponent implements OnInit {

    products: any[] = [];

    isLoading = false;

    productsDetails = productContent;

    productsImages = productsImages;

    productsRoutes = productsRoutes;

    productIcons = productIcons;

    rightArrowIcon = rightArrowIcon.arrowIcon;

    productsSku = productsSku;

    request = productContent.request;

    quote = productContent.quote;

    /**
     * Product coming from URL
     *
     * full
     * itemized
     * prelist
     */
    selectedProductType = '';

    /**
     * Actual product object selected from API
     */
    selectedProduct: any = null;

    constructor(
        public productsService: ProductsService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit(): void {

        /*
         * Read product from URL.
         *
         * Examples:
         *
         * ?product=full
         * ?product=itemized
         * ?product=prelist
         */
        this.route.queryParams.subscribe(params => {

            this.selectedProductType =
                (params['product'] || '')
                    .toString()
                    .toLowerCase();

            /*
             * If products are already loaded,
             * preselect immediately.
             */
            if (this.products.length > 0) {
                this.preselectProduct();
            }

        });

        this.listProducts();
    }


    listProducts(): void {

        this.isLoading = true;

        this.productsService
            .listProducts()
            .then((productRes: any) => {

                const nodes =
                    productRes &&
                    productRes.data &&
                    productRes.data.allProducts &&
                    productRes.data.allProducts.nodes
                        ? productRes.data.allProducts.nodes
                        : [];

                this.productsService
                    .formatProductsData(nodes)
                    .then((formatRes: any[]) => {

                        this.products =
                            formatRes || [];

                        /*
                         * Once API data is available,
                         * select the product from URL.
                         */
                        this.preselectProduct();

                        this.isLoading = false;

                    })
                    .catch((error) => {

                        console.error(
                            'Error formatting products:',
                            error
                        );

                        this.products = [];

                        this.isLoading = false;

                    });

            })
            .catch((error) => {

                console.error(
                    'Error loading products:',
                    error
                );

                this.products = [];

                this.isLoading = false;

            });
    }


    /**
     * Select product manually.
     */
    selectProduct(product: any): void {

        this.selectedProduct = product;

    }


    /**
     * Preselect product based on URL.
     */
    private preselectProduct(): void {

        if (!this.selectedProductType) {
            return;
        }

        this.selectedProduct =
            this.products.find(
                (product: any) =>
                    this.isMatchingProduct(
                        product,
                        this.selectedProductType
                    )
            ) || null;

        console.log(
            'URL product:',
            this.selectedProductType
        );

        console.log(
            'Preselected product:',
            this.selectedProduct
        );
    }


    /**
     * Match URL product type with API SKU.
     */
    private isMatchingProduct(
        product: any,
        productType: string
    ): boolean {

        const sku =
            (product.sku || '')
                .toString()
                .toLowerCase();


        /*
         * FULL
         */
        if (productType === 'full') {

            return (
                sku === 'full' ||
                sku === 'fullspekwo' ||
                sku ===
                    this.productsSku.fullSpekwo
                        .toString()
                        .toLowerCase()
            );

        }


        /*
         * ITEMIZED
         */
        if (productType === 'itemized') {

            return (
                sku === 'itemized' ||
                sku === 'itemised' ||
                sku === 'specificitem' ||
                sku ===
                    this.productsSku.specificItem
                        .toString()
                        .toLowerCase()
            );

        }


        /*
         * PRE-LIST
         */
        if (productType === 'prelist') {

            return (
                sku === 'prelist' ||
                sku === 'pre-list' ||
                sku ===
                    this.productsSku.preList
                        .toString()
                        .toLowerCase()
            );

        }


        return (
            sku === productType
        );
    }


    /**
     * Check whether a card is selected.
     */
    isSelected(product: any): boolean {

        return (
            !!this.selectedProduct &&
            this.selectedProduct.sku === product.sku
        );
    }


    /**
     * Continue to existing core product flow.
     */
    continueToQuote(): void {

        if (!this.selectedProduct) {
            return;
        }

        const sku =
            this.selectedProduct.sku;

        const route =
            this.productsRoutes[sku];

        if (!route) {

            console.error(
                'No route found for product:',
                sku
            );

            return;
        }

        this.router.navigate(
            [route],
            {
                queryParams: {
                    product: sku
                }
            }
        );
    }


    /**
     * Product getters used by HTML.
     */
    get fullProduct(): any {

        return this.products.find(
            (product: any) =>
                this.isMatchingProduct(
                    product,
                    'full'
                )
        );
    }


    get itemizedProduct(): any {

        return this.products.find(
            (product: any) =>
                this.isMatchingProduct(
                    product,
                    'itemized'
                )
        );
    }


    get preListProduct(): any {

        return this.products.find(
            (product: any) =>
                this.isMatchingProduct(
                    product,
                    'prelist'
                )
        );
    }

}